export const blockIconsCommunicationChatBubble = (
	<span className='material-symbols-outlined'>chat_bubble</span>
);
